import { useState, useCallback } from "react";
import { motion, AnimatePresence } from "motion/react";

/**
 * Kokonut-UI-style ripple button: click spawns an expanding ripple at the
 * pointer position. Copy-paste pattern — drop this file in and use it like
 * a regular button.
 */
export function RippleButton({ children, className = "", onClick, ...rest }) {
  const [ripples, setRipples] = useState([]);

  const handleClick = useCallback((e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const id = Date.now();
    setRipples((r) => [...r, { id, x: e.clientX - rect.left, y: e.clientY - rect.top }]);
    setTimeout(() => setRipples((r) => r.filter((rp) => rp.id !== id)), 650);
    onClick?.(e);
  }, [onClick]);

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`relative overflow-hidden rounded-md bg-cyan-500 hover:bg-cyan-400 text-slate-950 font-semibold px-6 py-3 transition-colors ${className}`}
      {...rest}
    >
      {children}
      <AnimatePresence>
        {ripples.map((r) => (
          <motion.span
            key={r.id}
            className="absolute rounded-full bg-white/40 pointer-events-none"
            style={{ left: r.x, top: r.y, translateX: "-50%", translateY: "-50%" }}
            initial={{ width: 0, height: 0, opacity: 0.6 }}
            animate={{ width: 220, height: 220, opacity: 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.65, ease: "easeOut" }}
          />
        ))}
      </AnimatePresence>
    </button>
  );
}

export default RippleButton;
